import styled from '@emotion/styled';

export const ShopBasicInfoWrapper = styled.div<{ gap: number }>`
  display: flex;
  gap: ${({ gap }) => gap}px;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;
